const SET_INCIDENTS = 'SET_INCIDENTS';
const SET_INCIDENTS_LOADED = 'SET_INCIDENTS_LOADED';
const SET_VISIBLE_INCIDENTS = 'SET_VISIBLE_INCIDENTS';
const ADD_SELECTED_INCIDENT = 'ADD_SELECTED_INCIDENT';
const REMOVE_SELECTED_INCIDENT = 'REMOVE_SELECTED_INCIDENT';
const CLEAR_SELECTED_INCIDENTS = 'CLEAR_SELECTED_INCIDENTS';
const SET_INCIDENT_LIST_VISIBLE = 'SET_INCIDENT_LIST_VISIBLE';
const SET_QUERIED_INCIDENTS_TOTAL = 'SET_QUERIED_INCIDENTS_TOTAL';
const SET_DISPLAYED_INCIDENTS_COUNT = 'SET_DISPLAYED_INCIDENTS_COUNT';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_INCIDENTS,
  SET_INCIDENTS_LOADED,
  SET_VISIBLE_INCIDENTS,
  ADD_SELECTED_INCIDENT,
  REMOVE_SELECTED_INCIDENT,
  CLEAR_SELECTED_INCIDENTS,
  SET_INCIDENT_LIST_VISIBLE,
  SET_QUERIED_INCIDENTS_TOTAL,
  SET_DISPLAYED_INCIDENTS_COUNT
};
